import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';

export const createField = <T = FieldConfig>(initOptions: Partial<T>) => (options?: Partial<T & FieldConfig>) => ({
  // containerClassNames is necessary to add default container classes into template
  containerClassNames: [''],

  ...initOptions,
  ...options,
});
